import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, toRefs } from 'vue';
  import Banner from './banner/index.vue';
  import Introduction from './introduction/index.vue';
  import { useRoute } from 'vue-router';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const route = useRoute()
  let keyWord = ref('')
  let listName = ref('')
  keyWord.value = route.query.keyWord as any
  listName.value = route.query.listName as any

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createVNode(Introduction, {
      keyWord: _unref(keyWord),
      listName: _unref(listName)
    }, null, 8, ["keyWord", "listName"]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})